// extracted by mini-css-extract-plugin
module.exports = {"contentWidthYoutube":"contentWidthYoutube-module__-txf2q__contentWidthYoutube"};